import BullhornIcon from '@gik/core/assets/img/icons/bullhorn.svg';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import { Button } from '@gik/ui/Button';
import type { IButtonProps } from '@gik/ui/Button/ButtonProps';
import { SvgIcon } from '@gik/ui/SvgIcon/SvgIcon';
import PlusIcon from '@heroicons/react/solid/PlusIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { inkindPageTourSelectors } from '../InkindPageTour/InkindPageTour';

export interface IAddInkindUserUpdateButtonProps extends IButtonProps {
  iconOnly?: boolean;
}

const blockName = 'add-inkind-user-update-button';

function AddInkindUserUpdateButtonComp({ iconOnly, ...buttonProps }: IAddInkindUserUpdateButtonProps) {
  const bem = useBemCN(blockName);
  const { t } = useTranslation();

  if (iconOnly) {
    return (
      <Button {...bem()} {...buttonProps} variant={'secondary'} circle>
        <SvgIcon Icon={PlusIcon} />
      </Button>
    );
  } else {
    return (
      <Button
        {...bem()}
        {...buttonProps}
        id={inkindPageTourSelectors.addUpdate}
        variant={'secondary'}
        prepend={<SvgIcon Icon={BullhornIcon} size="lg" />}
      >
        {t(translationKeys.AddUpdateButtonLabel)}
      </Button>
    );
  }
}

export const AddInkindUserUpdateButton = withComponentErrorBoundary(AddInkindUserUpdateButtonComp);
